import React, { Component } from "react";
import { Tabs } from "antd";

// icons
import { ReactComponent as IconApproval } from "../../assets/Approval.svg";
import { ReactComponent as IconPlanned } from "../../assets/Planned.svg";
import { ReactComponent as IconHistory } from "../../assets/history.svg";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectUserData } from "../../redux/user/user.selectors";
import CitCommodityListWithNewsPage from "./cit-commodityListWithNews.page";
import CitCommodityListPage from "./cit-commodityList.page";

const { TabPane } = Tabs;

/**
 * @description Parent component containing tab view.
 * @component
 */
class CitCommodity extends Component {
  state = { tabKey: 0 };
  render() {
    return (
      <div className="report-tabs">
        <Tabs
          // onChange={() => this.setState({ tabKey: Date.now() + "" })}
          animated={false}
          className={`main-content`}
          defaultActiveKey="101"
          tabPosition="bottom"
        >
          <TabPane
            // key={this.state.tabKey}
            // forceRender
            tab={
              <div className="tab-title-container">
                <div>
                  <IconApproval className="tab-title-image" />
                </div>
                News
              </div>
            }
            key={"101"}
          >
            <CitCommodityListWithNewsPage />
          </TabPane>

          <TabPane
            // forceRender
            tab={
              <div className="tab-title-container">
                <div>
                  <IconPlanned className="tab-title-image" />
                </div>
                Commodity
              </div>
            }
            key="102"
          >
            <CitCommodityListPage />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

export default connect(mapStateToProps, null)(CitCommodity);
